<template>
  <div class="other">
    <drag-modal :visible="$store.state.dislog.Laysuit" @cancel="reset" title="案件信息" width="660px">
      <a-form-model ref="newforms" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="案件类型" prop="cause_type">
          <a-select show-search v-model="form.cause_type" placeholder="请选择案件类型" :disabled="form.id ? true : false">
            <a-select-option
              v-for="d in [{ id: 1, tit: '诉讼', disabled: false }, { id: 2, tit: '仲裁', disabled: !$common.AccAUTH($store.state.Debinfo.info.accuser.id, 'arbitrate:index') }, { id: 3, tit: '公证', disabled: false }, { id: 4, tit: '调解', disabled: false }]"
              :key="d.id" :disabled="d.disabled">
              {{ d.tit }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="form.cause_type == 1 ? '原告' : '申请人'" prop="plaintiffs">
          <a-select show-search v-model="form.plaintiffs" placeholder="请选择"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" @blur="leaveAcc" @change="setChinaId"
            :allowClear="true" :default-active-first-option="false" :show-arrow="false" :filter-option="false"
            :not-found-content="null" mode="multiple">
            <a-select-option v-for="d in accuser" :key="d.id" :value="d.id">
              <Normap :tit='d.realname'>{{ d.realname }}</Normap>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="业务部门" prop="team_id" v-if="form.plaintiffs">
          <a-select show-search v-model="form.team_id" placeholder="请选择业务部门"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option v-for="d in teamList" :key="d.team.id">
              {{ d.team.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="form.cause_type == 1 ? '被告' : '被申请人'" prop="defendants">
          <a-select v-model="form.defendants" placeholder="请选择" show-search mode="multiple"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :filter-option="filterOption">
            <a-select-option v-for="i in alldefendantList" :key="i.id">
              {{ i.realname }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="案由" prop="cause_reason_id">
          <!-- <a-select show-search v-model="form.cause_reason_id" placeholder="请选择案由"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :filter-option="(input, option) =>
              option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
              ">
            <a-select-option v-for="d in cause_reason" :key="d.id" :value="d.id" :label="d.title">
              {{ d.title }}
            </a-select-option>
          </a-select> -->
          <a-tree-select v-model="form.cause_reason_id" show-search style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', maxWidth: '200px', overflow: 'auto' }" placeholder="请选择案由"
            allow-clear :treeDefaultExpandAll="false" :tree-data="cause_reason" :replace-fields="replaceFields"
            tree-node-filter-prop="title" :treeDefaultExpandedKeys="expandedKeys">
            <template #switcherIcon="{ expanded }">
              <!-- 利用 Ant Design Vue 内置的图标组件 DownOutlined 和 RightOutlined -->
              <down-outlined v-if="expanded" style="font-size: 18px; color: #1890ff;" />
              <right-outlined v-else style="font-size: 18px; color: #1890ff;" />
            </template>
            <template slot="treeNodeLabel" slot-scope="{ node }">
              <a-tooltip overlayClassName="custom-tip" :title="node.title" placement="top"
                :get-popup-container="() => document.body">
                <div class="tree-node-text">{{ node.title }}</div>
              </a-tooltip>
            </template>
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="法院地区：" prop="court">
          <a-cascader :options="options" placeholder="请选择" change-on-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model="form.court" @change="
              seachCourtList(form.court)
            form.court_id = null
              " />
        </a-form-model-item>
        <a-form-model-item label="管辖法院" prop="court_id">
          <a-select show-search v-model="form.court_id" placeholder="请选择法院"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="d in courtList" :key="d.id">
              <Normap :tit='d.title'>{{ d.title }}</Normap>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="仲裁机构地区：" prop="arb" v-if="form.cause_type == 2">
          <a-cascader :options="options" placeholder="请选择" change-on-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            :field-names="{ label: 'full_name', value: 'id', children: 'more' }" v-model="form.arb" @change="
              seachArbList(form.arb)
            form.arb_org_id = null
              " />
        </a-form-model-item>
        <a-form-model-item label="仲裁机构" prop="arb_org_id" v-if="form.cause_type == 2">
          <a-select show-search v-model="form.arb_org_id" placeholder="请选择仲裁机构"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" :allowClear="true"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null">
            <a-select-option v-for="d in arbList" :key="d.id">
              {{ d.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="金融机构" prop="bank_id">
          <a-select show-search v-model="form.bank_id" placeholder="请选择金融机构"
            :getPopupContainer="(triggerNode) => (triggerNode.parentNode)" :allowClear="true"
            :default-active-first-option="false" :filter-option="(input, option) =>
              option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
              ">
            <a-select-option v-for="d in bankList" :key="d.id" :value="d.id" :label="d.title">
              {{ d.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item :label="form.cause_type == 1 ? '诉讼案号' : '仲裁案号'" prop="no">
          <a-input v-model="form.no" :disabled="true" />
        </a-form-model-item> -->
        <a-form-model-item label="诉讼完毕：" prop="cause_is_complete">
          <a-select v-model='form.cause_is_complete' placeholder="请选择">
            <a-select-option :key="1">是</a-select-option>
            <a-select-option :key="0">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="代偿完毕：" prop="is_full_pay">
          <a-select v-model='form.is_full_pay' placeholder="请选择">
            <a-select-option :key="3">否</a-select-option>
            <a-select-option :key="2">是</a-select-option>
            <a-select-option :key="1">不详</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="重审案件" prop="is_retrial" v-if="form.cause_type == 1">
          <a-select v-model="form.is_retrial" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="1">是</a-select-option>
            <a-select-option :key="2">否</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="本金" prop="capital">
          <a-input v-model="form.capital" placeholder="请输入本金" min="1" @change="handleAmountInput"></a-input>
        </a-form-model-item>
        <a-form-model-item label="利息" prop="used_fee">
          <a-input v-model="form.used_fee" placeholder="请输入利息" @change="handleFeeInput"></a-input>
        </a-form-model-item>
        <a-form-model-item label="本案代偿明细：" prop="compensation">
          <div v-for="(item, index) in form.compensation" :key="index"
            style="display: flex;position: relative;;margin-bottom: 15px;margin-top: 5px;">
            <a-input-group style="display: flex;gap: 5px;align-items: center;">
              <a-date-picker v-model="item.time" placeholder="请选择时间"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode" valueFormat="YYYY-MM-DD"
                format="YYYY-MM-DD" type="date" style="width: 100%;flex: 1;" />
              <a-input v-model="item.amount" placeholder="请输入金额" style="flex: 1;border-radius: 4px;" />
            </a-input-group>
            <div class="twobtns">
              <a-icon type="plus-circle" class="i add" @click='add' v-if='index == 0' style="margin-right:10px;" />
              <a-icon type="minus-circle" class="i del" @click='del(index)' v-else />
            </div>
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item label="追究拒执" prop="is_payee_cancel">
          <a-select v-model="form.is_payee_cancel" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="1">否</a-select-option>
            <a-select-option :key="4">准备中</a-select-option>
            <a-select-option :key="2">刑事自诉</a-select-option>
            <a-select-option :key="3">检察院公诉</a-select-option>
          </a-select>
        </a-form-model-item> -->
        <!-- <a-form-model-item label="留置车辆 " prop="is_retain_car">
          <a-select v-model="form.is_retain_car" :getPopupContainer="(triggerNode) => triggerNode.parentNode"> -->
        <!-- <a-select-option :key="0">不详</a-select-option> -->
        <!-- <a-select-option :key="1">是</a-select-option> -->
        <!-- <a-select-option :key="2">否</a-select-option>
            <a-select-option :key="3">法院扣押</a-select-option>
            <a-select-option :key="4">{{ form.cause_type == 1 ? '原告' : '申请人' }}自行留置</a-select-option>
            <a-select-option :key="5">{{ form.cause_type == 1 ? '被告' : '被申请人' }}主动交付</a-select-option>
            <a-select-option :key="6">{{ form.cause_type == 1 ? '原告' : '申请人' }}提供线索由法院扣押</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="优先受偿" prop="is_first_compensation">
          <a-select v-model="form.is_first_compensation" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="0">不详</a-select-option>
            <a-select-option :key="1">支持</a-select-option>
            <a-select-option :key="2">未支持</a-select-option>
            <a-select-option :key="3">未主张</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="车辆首封" prop="is_first_ban">
          <a-select v-model="form.is_first_ban" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
            <a-select-option :key="0">不详</a-select-option>
            <a-select-option :key="1">是</a-select-option>
            <a-select-option :key="2">否</a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="margin-right: 20px; width: 148px">保存</a-button>
          </a-popconfirm>
          <a-button style="background: #b2c9e1; color: #fff; width: 148px" @click="reset">关闭</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>
<script>
import { DownOutlined, RightOutlined } from '@ant-design/icons-vue';
import { accuseList, debtorAll, getAccuserAll } from '@/server/api'
import { getDirectory, arbOrg } from '@/server/directory'
import city from '@/assets/js/city.json'
import { CaseAdd, CaseEdit, CauseAdd } from '@/server/debtor'
import { citySort } from '@/assets/js/unit'
import Validator from "@/assets/js/yz.js"
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}
export default {
  name: 'Laysuit',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      },

    },
    bankList: {
      type: Array,
      default: () => []
    },
    cause_reason: Array,
    alldefendantList: Array,
    accuserList: Array
  },
  data() {
    return {
      replaceFields: {
        children: 'child',
        title: 'title',
        key: 'id',
        value: 'id'
      },
      Validator,
      // bank: [],
      options: citySort(city),
      visible: false,
      expandedKeys: [-1],
      audit: [],
      rules: {
        cause_type: [{ required: true, message: '请选择案件类型', trigger: 'change' }],
        bank_id: [{ required: true, message: '请选择金融机构', trigger: 'change' }],
        plaintiffs: [{ required: true, message: '请选择原告/申请人', trigger: 'change' }],
        cause_type: [{ required: true, message: '请选择案件类型', trigger: 'change' }],
        defendants: [{ required: true, message: '请选择被告/被申请人', trigger: 'change' }],
        is_retrial: [{ required: true, message: '请选择是否为重审案件', trigger: 'change' }],
        court_id: [{ required: true, message: '请选择法院', trigger: 'blur' }],
        court: [{ required: true, message: '请选择法院地区', trigger: 'change' }],
        capital: [{ required: true, validator: Validator.amount.bind(this), trigger: 'blur' }],
        used_fee: [{ required: false, validator: Validator.amount.bind(this), trigger: 'blur' }],
        cause_reason_id: [{ required: true, message: '请选择案由', trigger: 'change' }],
        team_id: [{ required: true, message: '请选择业务部门', trigger: 'change' }],
      },
      debtorAll: [], //被告 被告+关联被告列表
      accuser: [], //原告列表
      arbList: [],
      courtList: [], //法院
      data: {
        limit: 50,
        page: 1,
        title: null,
      },
      accList: [],
      form: {
        cause_type: 1,
        arb_org_id: '',
        // exec_la_agent: '',
        bank_id: '',
        cause_reason_id: null,
        is_full_pay: null,
        cause_is_complete: null,
        // exec_agent: '',
        court: [],
        court_type: 1,
        team_id: null,
        debtor_id: this.$route.params.id,
        plaintiffs: [],
        // agent: null,
        court_id: '',
        defendants: [],
        no: null,
        used_fee: null,
        capital: null,
        chinaid: null,
        // is_payee_cancel: null,
        is_retrial: null,
        // is_retain_car: 2,
        // is_first_compensation: null,
        // is_first_ban: null,
        compensation: [{
          id: 0,
          time: '',
          amount: null
        }]
      },
    }
  },
  computed: {
    teamList() {
      if (!this.form.plaintiffs || this.form.plaintiffs.length === 0) {
        return null;
      }
      if (!this.accuser || this.accuser.length === 0) {
        return null;
      }
      const teams = this.form.plaintiffs.flatMap(ele => {
        const user = this.accuser.find(item => item.id === ele);
        return user.team || [];
      });
      return teams
    },
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.parties) {
          this.form.bank_id = newVal.bank ? newVal.bank.id : null
          this.form.cause_reason_id = newVal.reason && newVal.reason.id
          this.form.id = newVal.id ? newVal.id : null
          if (newVal.parties.plaintiff) {
            this.form.plaintiffs = newVal.parties.plaintiff.map(ele => ele.id);
          }
          if (newVal.parties.defendant) {
            let defendant = newVal.parties.defendant.map((ele) => ele.id)
            this.form.defendants = [...defendant]
          }
          this.form.team_id = newVal.team_id ? newVal.team_id : null
          this.form.is_full_pay = newVal.is_full_pay
          this.form.cause_is_complete = newVal.cause_is_complete
          this.form.capital = newVal.capital / 100
          this.form.used_fee = newVal.used_fee == 0 ? null : newVal.used_fee / 100
          this.form.cause_type = newVal.cause_type
          this.audit = newVal.audit
          this.form.court = newVal.courte
            ? [
              newVal.courte.province_id,
              newVal.courte.city_id,
              newVal.courte.area_id,
            ]
            : [110000]
          this.form.court_id = newVal.courte ? newVal.courte.id : ''
          this.seachCourtList(this.form.court)
          if (newVal.cause_type == 2) {
            const arb = [newVal.arb_org.province_id, newVal.arb_org.city_id, newVal.arb_org.area_id].filter(ele => { return ele })
            this.form.arb = arb
            this.seachArbList(arb)
            this.form.arb_org_id = newVal.arb_org.id
            this.form.is_retrial = null
          } else {
            this.form.is_retrial = newVal.is_retrial > 0 ? newVal.is_retrial : null
          }
        }
      },
      immediate: true,
    },
    accuserList: {
      immediate: true,
      handler(val) {
        this.accuser = val || []
      }
    },
    cause_reason: {
      handler(val) {
        this.handleDisableNode(val)
      },
    }
  },
  created() {
  },
  methods: {
    handleDisableNode(tree) {
      if (!Array.isArray(tree)) return
      tree.forEach(item => {
        // key 对应你的 id 字段
        if (item.id === -1) {
          item.disabled = true
        }
      })
    },
    add() {
      this.form.compensation.push({
        id: 0,
        time: '',
        amount: null
      })
    },
    del(index) {
      this.form.compensation.splice(index, 1)
    },
    handleAmountInput(e) {
      const invalidSymbols = /[^0-9.]/g;
      if (invalidSymbols.test(e.target.value)) {
        this.form.capital = ''
        return;
      } else {
        const value = e.target.value;
        e.target.value = Validator.formatAmount ? Validator.formatAmount(value) : value;
      }
    },
    handleFeeInput(e) {
      const invalidSymbols = /[^0-9.]/g;
      if (invalidSymbols.test(e.target.value)) {
        this.form.used_fee = ''
        return;
      } else {
        const value = e.target.value;
        e.target.value = Validator.formatAmount ? Validator.formatAmount(value) : value;
      }
    },
    isEdit(val) {
      // let bool =
      //   this.audit.filter((ele) => {
      //     return val.split(',').indexOf(ele.field) >= 0
      //   }).length > 0
      //     ? true
      //     : false
      // return bool
    },
    setChinaId(e) {
      this.form.team_id = null
      this.form.plaintiffs = e
    },
    confirm() {
      let form = JSON.parse(JSON.stringify(this.form))
      this.$refs.newforms.validate((valid) => {
        form.capital = (form.capital * 100).toFixed(0)
        form.used_fee = (form.used_fee * 100).toFixed(0)
        if (form.cause_type == 2) {
          delete form.arb
          delete form.is_retrial
        } else {
          delete form.arb
          delete form.arb_org_id
        }
        if (!form.compensation[0].time) {
          delete form.compensation
        }
        if (valid) {
          delete form.id
          CauseAdd(form).then((e) => {
            this.$store.dispatch('Case/getlist', {
              debtor_id: this.$route.params.id,
            })
            this.$message.success({ content: '新增成功', key: 'updatable' })
            this.reset()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset() {
      this.$emit('resh')
      this.$store.dispatch('openkey', { key: 'Laysuit', by: false })
      this.$refs.newforms.resetFields()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },

    seachCourtList(val) {
      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : ''
      getDirectory({
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }).then((e) => {
        this.courtList = e.list
      })
    },
    seachArbList(val) {
      //搜索法院
      let province_id = val[0],
        city_id = val.length > 1 ? val[1] : '',
        area_id = val.length > 2 ? val[2] : ''
      arbOrg({
        province_id: province_id,
        city_id: city_id,
        area_id: area_id,
      }, 'index').then((e) => {
        this.arbList = e.list
      })
    },
    leaveAcc() {
      if (!this.form.plaintiffs) {
        this.data.title = null
      }
    },

    // leaveCause() {
    //   if (!this.form.plaintiffs) {
    //     this.reasonData.title = null
    //     this.causeList();
    //   }
    // },
    // async causeSearch(name) {
    //   this.reasonData.title = name;
    //   await this.causeList();
    // },
  },
  components: {},
}
</script>
<style lang="less">
.yellow .ant-select-selection,
.yellow.ant-calendar-picker {
  border: 1px solid #ff9800 !important;
  opacity: 1;
  color: #ccc;
  /* border: 0 none; */
  background: none;
  border-radius: 4px;
}

/deep/ .ant-form-item-control-wrapper {
  position: relative;
}

.twobtns {
  position: absolute;
  width: 15%;
  max-width: 70px;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  padding-left: 20px;

  right: -65px;
  top: 50%;
  transform: translateY(-50%);

  .i {
    cursor: pointer;
  }

  .add {
    color: #118afc;
  }

  .del {
    color: #f00;
  }
}
</style>
<style>
.ant-select-tree-switcher {
  color: #1890ff !important;
}

.ant-select-tree-switcher:hover {
  color: #096dd9 !important;
}

.anticon {
  font-size: 16px !important;
}

.ant-select-dropdown-menu {
  /* 针对 Firefox 的样式 */
  scrollbar-width: thin;
  /* 可选值: 'auto', 'thin', 'none' */
  scrollbar-color: #c1c1c1 #f5f5f5;
  /* 第一个值是滑块颜色，第二个是轨道颜色 */
}

/* 针对 Chrome/Edge/Safari 的样式 */
.ant-select-dropdown-menu::-webkit-scrollbar {
  width: 6px;
}

.ant-select-dropdown-menu::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 6px;
}

.ant-select-dropdown-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 6px;
}

.ant-select-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>